import {connect} from 'react-redux';

import {InviteTeammatesJobModel} from '../../../../../libs/shared/core/src/models/api/jobModel';
import {computeJobProgress} from '../../../../../libs/shared/core/src/models/helpers/jobHelpers';
import {jobDeletedAction} from '../../../../../libs/shared/core/src/store/data/jobs/commonJobsActions';
import {
  createSelector,
  makeMapDispatchToProps,
  makeMapStateToProps,
} from '../../../../../srcCommon/helpers/reselectHelpers';
import {AppState} from '../../../../store/appState';
import {InviteTeammatesBanner} from './inviteTeammatesBanner';

/*
 * Props.
 */

interface InviteTeammatesBannerContainerProps {
  job: InviteTeammatesJobModel;
}

/*
 * Selectors.
 */

function getJob(_state: AppState, props: InviteTeammatesBannerContainerProps) {
  return props.job;
}

function makeGetProgress() {
  return createSelector([getJob], (job) => computeJobProgress(job));
}

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps<InviteTeammatesBannerContainerProps>()(() => ({
  progress: makeGetProgress(),
}));

const mapDispatchToProps = makeMapDispatchToProps()(() => ({
  onDeleteJob: jobDeletedAction,
}));

export const InviteTeammatesBannerContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(InviteTeammatesBanner);
